(function ($) {
    $.fn.reverse = function(fn) {
       var i = this.length;

       while(i) {
            i--;
            fn.call(this[i], i, this[i]);
       }
    };

    $(document).ready(function () {
        if ($('#form-ppf-quest').length) {
            grecaptcha.ready(function() {
                grecaptcha.execute(rissb_var.recaptcha_site_key, {action: 'user_form'}).then(function(token) {
                    $('[name="recaptcha_token"]').val(token);
                });
            });
        }

        if ($('#gform_' + rissb_var.ranking_form_id).length) {
            var sortSourceItems = function () {
                var $ul =  $('ul.src');
                var $li = $ul.children('li').get();

                $li.sort(function (a, b) {
                    return $(a).text().toUpperCase().localeCompare($(b).text().toUpperCase());
                });

                $.each($li, function (idx, itm) {
                    $ul.append(itm);
                });

                $ul.find('li').each(function () {
                    var $t = $(this);

                    if ($t.is(':empty')) {
                        $t.remove();
                    }
                });
            };

            var dragItems = function() {
                $('ul.src div.itm, ul.dst div.ph div.itm').draggable({
                    start: function (e, ui) {
                        var $start = $(this);
                        var $itm   = $(e.toElement);

                        $start.css({
                            'z-index': '100'
                        });
                    },
                    stop: function (e, ui) {
                        var $stop = $(this);
                        var $itm  = $(e.originalEvent.target);

                        $stop.animate({
                            top: '0px',
                            left: '0px',
                            'z-index': '0'
                        });

                        sortSourceItems();
                    },
                    revert: 'invalid',
                });
            };

            sortSourceItems();
            dragItems();

            $('ul.src, ul.dst div.ph').droppable({
                drop: function (e, ui) {
                    var $drop        = $(this);
                    var $itm         = $(e.originalEvent.target);
                    var $itm2        = $('.ui-draggable-dragging');
                    var is_fixed     = $('ul.src').hasClass('hover');
                    var moveLastItem = false;

                    if ($drop.parent().hasClass('otr')) {
                        if (!$drop.find('.itm').length) {
                            if (!is_fixed) {
                                var $citm = $itm.clone();

                                $citm.attr('class', 'itm');
                                $citm.attr('style', '');
                                $drop.append($citm);
                            }

                            if (!$itm.parent().hasClass('ph')) {
                                if (!is_fixed) {
                                    $itm.parent().remove();
                                } else {
                                    var $citm2 = $itm2.clone();

                                    $citm2.attr('class', 'itm');
                                    $citm2.attr('style', '');
                                    $drop.append($citm2);
                                    $itm2.parent().remove();
                                }
                            } else {
                                if (!is_fixed) {
                                    $itm.remove();
                                } else {
                                    var $citm2 = $itm2.clone();

                                    $citm2.attr('class', 'itm');
                                    $citm2.attr('style', '');
                                    $drop.append($citm2);
                                    $itm2.remove();
                                }
                            }
                        } else {
                            // when there is already an item in the cell
                            // first we move everything one step lower
                            // if it's in the last element, we move it back to source
                            // for the item we're moving to, use the original cell
                            var $oitm     = $drop.find('.itm');
                            var $src_citm = $oitm.clone();
                            var $src      = $('.ranking ul.src');

                            if ($itm2.find('input').val() == $drop.find('.itm input').val()) {
                                return; // do nothing to prevent moving down all other items
                            }

                            $drop.closest('li').nextAll('ul.dst li').reverse(function () {
                                var $currentLi        = $(this);
                                var $nextLi           = $currentLi.next('ul.dst li');
                                var $currentItm       = $currentLi.find('.itm');
                                var $currentItm_clone = $currentItm.clone();

                                if ($currentItm.text() === $itm2.text()) {
                                    return;
                                }

                                $currentItm_clone.attr('class', 'itm');
                                $currentItm_clone.attr('style', '');

                                if (!$nextLi.length) {
                                    if ($currentItm.length) {
                                        $src.append($('<li>').append($currentItm_clone));
                                        moveLastItem = true;
                                    }
                                } else {
                                    // for the rest of the items, we move it one step lower
                                    $nextLi.find('div.ph').empty();

                                    if ($currentItm.length) {
                                        $nextLi.find('div.ph').append($currentItm_clone);
                                    }

                                    $currentItm.remove();
                                }
                            });

                            var $oitm_clone = $oitm.clone();

                            $oitm_clone.attr('class', 'itm');
                            $oitm_clone.attr('style', '');
                            $drop.empty();
                            $drop.closest('li').next('ul.dst li').find('div.ph').empty().append($oitm_clone);

                            $oitm.remove();

                            if (!is_fixed) {
                                var $dst_citm = $itm.clone();

                                $dst_citm.attr('class', 'itm');
                                $dst_citm.attr('style', '');
                                $drop.append($dst_citm);
                            } else {
                                var $dst_citm2 = $itm2.clone();

                                $dst_citm2.attr('class', 'itm');
                                $dst_citm2.attr('style', '');
                                $drop.append($dst_citm2);
                                $itm2.remove();
                            }

                            $itm.remove();
                        }
                    } else {
                        if ($itm.parent().hasClass('ph')) {
                            var $citm = $itm.clone();

                            $citm.attr('class', 'itm');
                            $citm.attr('style', '');
                            $drop.append($('<li>').append($citm));
                            $itm.remove();
                        }
                    }

                    dragItems();

                    if (moveLastItem) {
                        alert('Please note your action has shifted all the products down by one rank. As there was a product already ranked last, it was moved from the ‘Ranking Column’ to the ‘Source Column.’');
                    }
                }
            });

            $(window).on('scroll', function() {
                var winTop    = $(document).scrollTop();
                var winHeight = $(window).height();
                var $src      = $('ul.src');

                if (winTop > 650 && (($src.height() + 80) < winHeight)) {
                    $src.addClass('hover');
                } else {
                    $src.removeClass('hover');
                }
            });

            $('#gform_' + rissb_var.ranking_form_id).on('click', '[type="submit"]', function (e) {
                if ($('.ranking div.src ul.src li').length) {
                    $('#modal-ppf-warning').modal('show');
                    e.preventDefault();
                    return false;
                } else {
                    $('#modal-ppf-review').modal('show');
                    e.preventDefault();
                    return false;
                }
            });

            $(document).on('click', '#modal-ppf-review .js-btn-submit', function () {
                $('#modal-ppf-review').modal('hide');
                $('#gform_' + rissb_var.ranking_form_id).submit();
            });
        }
    });
})(jQuery);

